import { useSelector } from 'react-redux';
import { DefaultRootState, store } from '@reduxLocal/persistState';
import apis from '@api/api';
import {
	REMOVE_MAIL_SCOPE,
	UPDATE_MAIL_COUNT,
	SET_MAIL_RETRIEVAL_ERROR,
} from '@reduxLocal/actions/types';
import { googleAuths } from '@reduxLocal/selectors/userSelectors';

export default async function getEmailCount() {
	const { mail, google } =
		store.getState().promiseData.data.userData.authentications;
	try {
		const details = mail.mailType === 'google' ? google : null;

		if (mail.mailAuthenticated && details) {
			const res = await apis.getGmailCount(
				details?.googleId,
				details?.accessToken
			);
			// The interceptor handles token refresh automatically on 401 errors
			if (res && res.data) {
				const count = res.data;
				store.dispatch({
					type: UPDATE_MAIL_COUNT,
					payload: count?.messagesUnread,
				});
				return true;
			}
		} else {
			console.error('Mail not authenticated');
		}
	} catch (error) {
		console.error('Failed to get mail count:', error);
		// Check if it's a duplicate request error
		if (
			error?.isDuplicate &&
			error?.message === 'Duplicate request prevented'
		) {
			store.dispatch({
				type: SET_MAIL_RETRIEVAL_ERROR,
				payload: {
					message:
						'Failed to get mail count: Duplicate request prevented',
					isDuplicate: true,
					requiresReauth: false, // Duplicate requests don't require re-auth
					timestamp: Date.now(),
				},
			});
		} else if (
			error?.response?.status === 401 ||
			error?.response?.status === 403
		) {
			// Authentication errors suggest re-authentication may be needed
			store.dispatch({
				type: SET_MAIL_RETRIEVAL_ERROR,
				payload: {
					message: `Failed to get mail count: ${error?.response?.status === 401 ? 'Authentication failed' : 'Access denied'}`,
					requiresReauth: true,
					timestamp: Date.now(),
				},
			});
		} else if (
			error?.message?.includes('token') ||
			error?.message?.includes('auth')
		) {
			// Token or auth related errors
			store.dispatch({
				type: SET_MAIL_RETRIEVAL_ERROR,
				payload: {
					message: `Failed to get mail count: ${error?.message || 'Authentication error'}`,
					requiresReauth: true,
					timestamp: Date.now(),
				},
			});
		} else {
			// Other errors - may or may not require re-auth
			store.dispatch({
				type: SET_MAIL_RETRIEVAL_ERROR,
				payload: {
					message: `Failed to get mail count: ${error?.message || 'Unknown error'}`,
					requiresReauth: false,
					timestamp: Date.now(),
				},
			});
		}
		// The interceptor will have attempted token refresh and retry
		// If it still fails, the error modal will be shown by the interceptor
	}

	return false;
}
